const resources = {
    showMore: 'Afficher plus',
    rougeBadge: 'ROUGE',
    signInToAccess: 'Ouvrez une session pour accéder',
    joinToAccess: 'Adhérer pour accéder',
    viewAll: 'Voir tout'
};

export default function getResource(label) {
    return resources[label];
}
